import React from 'react';
import moment from 'moment/moment';
import Tooltip from '@mui/material/Tooltip';
import { DateFormats } from 'constants/common';
import { MUITableColumn } from 'components/shared/MUITable';
import { ChecklistRtl, CopyAll, Edit } from '@mui/icons-material';
import { FormControlLabel, IconButton, Stack, Switch, Typography } from '@mui/material';

import { ApplyRulesCell } from './ApplyRulesCell';
import { ListSectionActions, TemplateRow } from './ListSection';

const equalWidth = {
  align: 'left' as const,
  sx: {
    width: '20%',
  },
};

export function createColumns(
  actions: ListSectionActions,
  isActiveStatusSetting: boolean
): MUITableColumn<TemplateRow>[] {
  return [
    {
      header: 'Template Name',
      renderKey: 'name',
      headerCell: equalWidth,
      cellProps: equalWidth,
      renderCell: row => <Typography>{row.name}</Typography>,
    },
    {
      header: 'Apply Business Rules',
      renderKey: 'paymentType',
      headerCell: equalWidth,
      cellProps: equalWidth,
      renderCell: row => (
        <ApplyRulesCell
          paymentType={String(row.paymentType ?? '')}
          applyingFor={String(row.applyingFor ?? '')}
          equipmentCondition={String(row.equipmentCondition ?? '')}
        />
      ),
    },
    {
      header: 'Created At',
      renderKey: 'createdDateTime',
      headerCell: equalWidth,
      cellProps: equalWidth,
      renderCell: row => (
        <Typography>{moment(row.createdDateTime).format(DateFormats.DateTimeMedium24Hour)}</Typography>
      ),
    },
    {
      header: 'Last Updated',
      renderKey: 'modifiedDateTime',
      headerCell: equalWidth,
      cellProps: equalWidth,
      renderCell: row => (
        <Typography>
          {row.modifiedDateTime ? moment(row.modifiedDateTime).format(DateFormats.DateTimeMedium24Hour) : '-'}
        </Typography>
      ),
    },
    {
      header: 'Action',
      renderKey: 'id',
      headerCell: equalWidth,
      cellProps: equalWidth,
      renderCell: row => (
        <Stack direction="row" gap="0.5rem" justifyContent="flex-start" flexWrap="wrap">
          <FormControlLabel
            label="Active"
            control={
              <Switch
                size="small"
                checked={row.isActive === 'true'}
                disabled={isActiveStatusSetting}
                onChange={async _ => {
                  await actions.onSetActiveStatus(row.id);
                }}
              />
            }
          />

          <Tooltip title="Copy template and close reasons">
            <IconButton
              className="icon-btn-bordered"
              onClick={() => {
                actions.onCopyTemplate(row.id);
              }}
            >
              <CopyAll color="primary" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Close reasons">
            <IconButton
              className="icon-btn-bordered"
              onClick={() => {
                actions.onRedirectToCloseReasons(row.id);
              }}
            >
              <ChecklistRtl color="primary" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Edit template">
            <IconButton
              className="icon-btn-bordered"
              onClick={async () => {
                await actions.onEditTemplate(row.id);
              }}
            >
              <Edit color="primary" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];
}
